import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Icon, { GLYPHS } from '../../../common/icon';

const Text = (props) => {
  const [value, setValue] = useState('');
  return (
    <div>
      <div className="u-flex u-align-items-center">
        <div className="c-nps-scale-popup__success-icon">
          <Icon glyph={GLYPHS.check} />
        </div>
        <p className="c-nps-scale-popup__title">
          Thanks for your feedback!
        </p>
      </div>
      <textarea
        rows="1"
        className="c-nps-scale-popup__textarea"
        placeholder={props.placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <div className="c-nps-scale-popup__controls">
        <button
          className="c-btn c-btn--grey"
          onClick={() => props.onCancel(value)}
        >
          Cancel
        </button>
        <button
          className="c-btn"
          disabled={!value}
          onClick={() => props.onSave(value)}
        >
          Save
        </button>
      </div>
    </div>
  );
};

Text.propTypes = {
  placeholder: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default Text;
